import React from "react";
import store from "../../../store/index";
import { Redirect } from "react-router-dom";
import UnAuthorized from "../../../component/partials/other/UnAuthorized";
import UserIsNotPublisher from "../../../component/partials/other/UserIsNotPublisher";

const isUserFillInfo = (component) => {
  const mainStore = store.getState().main;
  if (
    mainStore.firstnameUser == null ||
    mainStore.lastnameUser == null ||
    mainStore.categoryUser == null
  ) {
    return {
      status: false,
      routeObject: <Redirect to="/user/info" />,
    };
  }

  return {
    status: true,
    routeObject: component,
  };
};

const isUserLogin = (component) => {
  const mainStore = store.getState().main;
  if (!mainStore.isUserLoggedIn) {
    return {
      status: false,
      routeObject: <Redirect to="/login" />,
    };
  }

  return {
    status: true,
    routeObject: component,
  };
};

const isUserHasPublisherPermission = (component) => {
  const mainStore = store.getState().main;
  if (!mainStore.permissionsUser.includes("add-site-publisher-via-user")) {
    return {
      status: false,
      routeObject: <Redirect to="/you-are-not-publisher" />,
    };
  }

  return {
    status: true,
    routeObject: component,
  };
};

const isUserLogout = (component) => {
  const mainStore = store.getState().main;

  if (mainStore.isUserLoggedIn) {
    return {
      status: false,
      routeObject: <Redirect to="/" />,
    };
  }

  return {
    status: true,
    routeObject: component,
  };
};

export default {
  isUserFillInfo,
  isUserLogin,
  isUserLogout,
  isUserHasPublisherPermission,
};
